/**  @jsx jsx */
import { jsx } from 'theme-ui';
import ProducerPage from '@bottlebooks/gatsby-theme-event/src/components/ExhibitorPage/ExhibitorPage';
import { graphql } from 'gatsby';

export default function HomePage(props) {
  return <ProducerPage {...props} />;
}

export const fragment = graphql`
  fragment HomePage on Query {
    exhibitor {
      ...ExhibitorPage
    }
  }
  fragment HomePage_ProductList on Event {
    id
    slug
    ...ExhibitorPage_ProductList
  }
`;
